import React, { useEffect, useState } from "react";
import callApi from "services/api";
import { setLoading } from "state/slices/loaderSlice";
import { useDispatch } from "react-redux";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { selectRole } from "state/slices/roleSlice";
const UnderSectionReport = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [reportData, setReportData] = useState([]);

  useEffect(() => {
    loadReport();
  }, []);
  const role = useSelector(selectRole);
  const loadReport = async () => {
    dispatch(setLoading(true));
    const res = await callApi(
      "/v1/api/under-section/report",
      "GET",
      null,
      false,
      true
    );
    if (res?.success) {
      setReportData(res.body?.body || []);
    }
    dispatch(setLoading(false));
  };

  const openCaseList = (actName, actId, statusType) => {
    navigate("/r-ca", {
      state: {
        filterType: "act",
        actId: actId,
        actName: actName,
        statusType: statusType,
        period: "all"
      },
    });
  };

  const renderCell = (value, bgColor, actName, actId, statusType) => {
    if (value === 0)
      return (
        <td style={{ backgroundColor: bgColor }} className="text-white">
          {value}
        </td>
      );

    return (
      <td
        style={{
          backgroundColor: bgColor,
          cursor: "pointer",
          textDecoration: "underline",
        }}
        className="text-white"
        onClick={() => openCaseList(actName, actId, statusType)}
      >
        {value}
      </td>
    );
  };

  const total = {
    sent: 0,
    completed: 0,
    pending: 0,
  };

  reportData.forEach((r) => {
    total.sent += r.sent;
    total.completed += r.completed;
    total.pending += r.pending;
  });
  return (
    <>
      <div className="container mb-3">
        <div className="card">
          <div
            className="ms-3 me-3 mt-3 p-2 d-flex justify-content-between"
            style={{ backgroundColor: "#262E3D", borderRadius: "8px" }}
          >
            <div className="d-flex align-items-center">
              <span className="card-title text-white m-0">Under Section Report</span>
            </div>

            {role === "Admin" && (
              <button
                className="btn btn-sm btn-success"
                onClick={() =>
                  navigate("/grl", {
                    state: { reportType: "UnderSectionReport" },
                  })
                }
              >
                Generate Report
              </button>
            )}
          </div>
          <div className="card-body">
            <div className="table-responsive">
              <table className="table table-bordered text-center align-middle table-hover table-striped">
                <thead>
                  <tr>
                    <th
                      style={{ backgroundColor: "#262E3D" }}
                      className="text-center align-middle"
                    >
                      <span className="text-white">Acts Detail</span>
                    </th>
                    <th
                      style={{ backgroundColor: "#262E3D" }}
                      className="text-center align-middle"
                    >
                      <span className="text-white">Sent Cases</span>
                    </th>
                    <th
                      style={{ backgroundColor: "#262E3D" }}
                      className="text-center align-middle"
                    >
                      <span className="text-white">Cases Successfully Completed</span>
                    </th>
                    <th
                      style={{ backgroundColor: "#262E3D" }}
                      className="text-center align-middle"
                    >
                      <span className="text-white">Pending Cases</span>
                    </th>
                  </tr>
                </thead>

                <tbody>
                  {reportData.map((row, idx) => (
                    <tr className="font-weight-bold" key={idx}>
                      <td className="bg-warning text-white">{row.act}</td>

                      {renderCell(row.sent, "#00B0F0", row.act, row.actId, "sent")}
                      {renderCell(row.completed, "#00FF90", row.act, row.actId, "completed")}
                      {renderCell(row.pending, "#FF4D4D", row.act, row.actId, "pending")}
                    </tr>
                  ))}

                  <tr className="text-white font-weight-bold">
                    <td
                      style={{ backgroundColor: "#262E3D" }}
                      className="text-white"
                    >
                      Total:
                    </td>
                    <td
                      style={{ backgroundColor: "#262E3D" }}
                      className="text-white"
                    >
                      {total.sent}
                    </td>
                    <td
                      style={{ backgroundColor: "#262E3D" }}
                      className="text-white"
                    >
                      {total.completed}
                    </td>
                    <td
                      style={{ backgroundColor: "#262E3D" }}
                      className="text-white"
                    >
                      {total.pending}
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

          </div>
        </div>
      </div>
    </>
  );
};

export default UnderSectionReport;
